module.exports = __webpack_public_path__ + "static/img/David-Klemmer.7f0ddfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Klemmer.jpg
// module id = I4mr
// module chunks = 0